export default function SectionHead({ index, eyebrow, title, lede, as: Heading = 'h2' }) {
  return (
    <header className={`section-head${lede ? ' section-head--split' : ''}`}>
      <p className="section-label" data-reveal="fade">
        {index ? <span className="section-label__index">{index}</span> : null}
        <span className="section-label__name">{eyebrow}</span>
      </p>
      <Heading className="section-head__title display" data-reveal style={{ '--reveal-delay': '60ms' }}>
        {title}
      </Heading>
      {lede ? (
        <p className="section-head__lede lede" data-reveal style={{ '--reveal-delay': '160ms' }}>
          {lede}
        </p>
      ) : null}
    </header>
  );
}
